import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "L'indépendance totale, au service de vos intérêts",
    content:
      "Contrairement aux agents d'une seule compagnie, ASSU-FRANCE négocie librement auprès de plus de 40 assureurs majeurs pour dénicher l'offre parfaite — au meilleur prix, sans conflit d'intérêt.",
  },
  {
    number: "02",
    title: "Un accompagnement humain et dédié",
    content:
      "Fini les plateformes impersonnelles. Vous disposez d'un conseiller attitré, joignable directement par ligne directe et email, qui connaît votre dossier et votre histoire.",
  },
  {
    number: "03",
    title: "Des sinistres défendus avec pugnacité",
    content:
      "En cas de coup dur, nous défendons rigoureusement votre dossier face aux compagnies pour garantir une indemnisation rapide, juste et sans paperasse inutile.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifeste" data-testid="manifesto-chapters-section" className="relative py-24 sm:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 grid lg:grid-cols-[0.9fr_1.1fr] gap-16 lg:gap-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="lg:sticky lg:top-36 self-start"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber/90 mb-6 flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-amber/60" /> Le manifeste
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-ivory text-balance">
            Trois engagements.{" "}
            <span className="italic text-amber">Zéro compromis.</span>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ivory/55 max-w-md">
            Le courtage n'est pas une question de contrats, mais de confiance.
            Voici ce qui fonde chaque relation ASSU-FRANCE depuis le premier jour.
          </p>
        </motion.div>

        <div>
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.number}
              data-testid={`manifesto-chapter-${c.number}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="group border-t hairline py-12 sm:py-16 grid sm:grid-cols-[120px_1fr] gap-6 sm:gap-10 items-start"
            >
              <span className="chapter-number font-serif text-7xl sm:text-8xl font-semibold leading-none select-none transition-all duration-500 group-hover:[-webkit-text-stroke-color:rgba(212,175,55,0.9)]">
                {c.number}
              </span>
              <div>
                <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-ivory leading-snug">
                  {c.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-ivory/55 max-w-xl">{c.content}</p>
              </div>
            </motion.article>
          ))}
          <div className="border-t hairline" />
        </div>
      </div>
    </section>
  );
}
